let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dDndc")).then(() => parcelRequire('h6EOm'));